import {
  Component,
  inject,
  Input,
} from '@angular/core';
import {RecordsTableService} from "../../../../../services/records-table.service";
import {RecordTableColumnParams} from "../../../../../types/records-table.types";
import {ColumnParamsStateService} from "../../../../../services/table-services/column-params-state.service";
import {TableGroupHeaderService} from "../../../../../services/table-services/table-group-header.service";
import {TableContextService} from "../../../../../services/table-services/table-context.service";

@Component({
  selector: 'div[app-table-group-header]',
  standalone: false,
  templateUrl: './table-group-header.component.html',
  styleUrls: [
    '../../../records-table-view.component.scss',
    './table-group-header.component.scss'
  ]
})
export class TableGroupHeaderComponent {
  @Input({ required: true }) resourceParamsKey: string = '';
  @Input({ required: true }) isAnyTableActionAvailable: boolean = false;

  public columnParamsStateService: ColumnParamsStateService = inject(ColumnParamsStateService);
  private recordsTableService: RecordsTableService = inject(RecordsTableService);
  private tableGroupHeaderService: TableGroupHeaderService = inject(TableGroupHeaderService);
  private tableContextService: TableContextService = inject(TableContextService);

  public isColumnDisplayed(columnParams: RecordTableColumnParams): boolean {
    if (columnParams.sticky) { return true; }

    return this.isGroupControllerDisplayed(columnParams) ? true : this.recordsTableService.isColumnDisplayed(columnParams);
  }

  public isColumnInGroupShouldBeDisplayed(columnParams: RecordTableColumnParams): boolean {
    if (!columnParams.columnProperties.GROUP) { return false; }
    if (columnParams.sticky) { return false; }

    return !columnParams.hiddenGroupPlaceholder || this.isGroupControllerDisplayed(columnParams);
  }

  public getGroupColor(columnParams: RecordTableColumnParams): string {
    const columnGroupId = columnParams.columnProperties.GROUP?.id;
    if (!columnGroupId) { return 'transparent';}

    const columnGroupParams = this.columnParamsStateService.getColumnParamsByKey(this.resourceParamsKey)?.find(i => i.columnProperties.GROUP?.id === columnGroupId);

    if (!columnGroupParams) { return 'transparent'; }

    return this.tableGroupHeaderService.getGroupColor(columnParams);
  }

  public isGroupControllerDisplayed(columnParams: RecordTableColumnParams): boolean {
    const currentGroupId = columnParams.columnProperties.GROUP?.id;
    if (!currentGroupId) { return false; }

    const columnsInGroup = this.columnParamsStateService.getColumnParamsByKey(this.resourceParamsKey);
    const firstColumnInGroup = columnsInGroup?.find(column =>
      column.columnProperties.GROUP?.id === currentGroupId && !column.sticky
    );

    return firstColumnInGroup?.key === columnParams.key;
  }

  public isLastColumnInGroup(columnParams: RecordTableColumnParams): boolean {
    const currentGroupId = columnParams.columnProperties.GROUP?.id;
    if (!currentGroupId) { return false; }

    const columnsInGroup = this.columnParamsStateService.getColumnParamsByKey(this.resourceParamsKey);
    const groupColumns = columnsInGroup?.filter(column =>
      column.columnProperties.GROUP?.id === currentGroupId && !column.sticky
    );

    if (!groupColumns?.length) { return false; }

    const lastColumnInGroup = groupColumns[groupColumns.length - 1];
    return lastColumnInGroup.key === columnParams.key;
  }

  public getWidth(columnParam: RecordTableColumnParams): number {
    return columnParam.hiddenGroup && !columnParam.sticky ? 50 : this.recordsTableService.getColumnWidth(columnParam, this.tableContextService.getTableId());
  }

  public getLeftPositionForSticky(width?: number): Record<string, string> | null {
    return (width === undefined || width === null) ? null : { 'left': width === 1 ? '0' : `${width}px` };
  }

  public toggleGroupVisibility(columnParams: RecordTableColumnParams): void {
    this.tableGroupHeaderService.toggleGroupVisibility(this.resourceParamsKey, columnParams);
  }
}
